module.exports = __webpack_public_path__ + "static/media/letter_send.1e357c89.svg";